import { ViewModel,View } from "binder"
import { AccountGatewaySelectorViewModel } from "src/erp/arap/rawData/accountGatewaySelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IGateway, IReceiveInfoProvider } from "../IGateway";
import  { AccountGatewayView } from "./accountGateway-view"
import { translate } from "src/common/utilities";

export class AccountGatewayViewModel extends ViewModel implements IGateway{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    get title(): string {
        return translate("accountGateway-viewModel.deposit",{});
    }
    initialLoad(): void {
        this.accountSelector = new AccountGatewaySelectorViewModel(this);
    }
    
    GetDefaultView(): View <ViewModel> {
        return new AccountGatewayView();
    }
    public getTypeId(): string {
        return "VM-E1D2C341-E8FB-4824-88DE-B8BFEFE6302C"
    }
    public set accountSelector(v: AccountGatewaySelectorViewModel) { this._accountSelector = v; } public get accountSelector(): AccountGatewaySelectorViewModel { return this._accountSelector;} private _accountSelector: AccountGatewaySelectorViewModel;
    
    async save(dataProvider: IReceiveInfoProvider): Promise<any> {
        return await ServerConnection.callServer('Complex/ArapServices/CreateTransferReceivable',{
            ReceivableInfo:dataProvider.getBaseReceivableInfoDto(),
            AccountId:this.accountSelector.selectedItem.id,
            TraceCode:""
        }); 
    }
    validate(): string[] {
        let result = [];
        if(this.accountSelector.selectedItem==null){
            result.push(translate("accountGateway-viewModel.destinationAccount",{}));
        }
        return result;
    }
}
